import Helpers from "./helpers";

export default class ProductVariants {

	private activeClass = 'c-product__variants__link--active';
	private doneClass = 'js-product-variant-done';

	constructor(elements: HTMLElement[]) {

		if (!elements.length) return;

		this.attachEvents(elements);

	}

	private attachEvents(elements: HTMLElement[]) {

		for (let i = 0; i < elements.length; i++) {

			let element = elements[i] as HTMLElement;

			element.addEventListener('mouseenter', (e) => {

				if (!Helpers.hasUserTouched()) {

					this.handleVariantInteraction(e, false);

				}

			});

			element.addEventListener('focus', (e) => {

				this.handleVariantInteraction(e, false);


			});

			element.addEventListener('click', (e) => {

				this.handleVariantInteraction(e, true);
				return false;

			});

			element.classList.add(this.doneClass);

		}

	}

	private handleVariantInteraction(e: Event, checkAndRedirect: Boolean) {

		const target = e.target as HTMLElement;

		const imageSrc = target.getAttribute('data-image');
		const product = target.closest('.js-product') as HTMLElement;
		const variants = product.querySelectorAll('.js-product-variant');
		const variantImage = product.querySelector('.js-product-variant-image') as HTMLElement;

		if (checkAndRedirect && target.classList.contains(this.activeClass)) {

			window.location.href = target.getAttribute('href');

		}

		this.updateVariants(variants);

		target.classList.add(this.activeClass);

		this.updateImage(imageSrc, variantImage, product);

		e.preventDefault();
		e.stopPropagation();

	}

	private updateVariants(variants: NodeList) {

		for (let i = 0; i < variants.length; i++) {

			let variant = variants[i] as HTMLElement;
			variant.classList.remove(this.activeClass);

		}

	}

	private updateImage(src: string, image: HTMLElement, product: HTMLElement) {

		if (src) {

			if (image) {

				image.style.display = 'block';
				image.querySelector('.js-product-variant-image-webp')?.setAttribute('srcset', `${src}&format=webp`);
				image.querySelector('.js-product-variant-image-default')?.setAttribute('src', src);

			} else {

				const markup = this.getVariantImage(src);
				product.querySelector('.js-product-image').insertAdjacentHTML('beforeend', markup);

			}

		} else {

			if (image) { image.style.display = 'none'; }

		}

	}

	private getVariantImage(src: string) {

		return `<picture class="js-product-variant-image" style="opacity: 1; display: block;">
			<source srcset="${src}&format=webp" type="image/webp" class="js-product-variant-image-webp">
			<img src="${src}" tabindex="-1" alt="" loading="eager" width="380" height="380" data-test="primary-image-variant-image">
		</picture>`;

	}

}

